<ng-container *ngIf="config && group?.get(controlName); else emptyField">
  <div class="">
    <form [formGroup]="group">

      <div class="flex" [ngClass]="['checkbox','radio'].includes(config?.type!)?'flex-row':'flex-column'">
        <label *ngIf="config.label"
          [ngClass]="['checkbox','radio'].includes(config?.type!)?'white-space-nowrap	mr-2':'white-space-normal w-full mb-1'">
          {{ config.label }}
          <i *ngIf="config?.validators?.required" class="pi pi-asterisk text-red-600	text-xs	"></i>
        </label>

        @if(config!.type==='text-search-box') {
        <div class="flex align-items-center">
          <input class="w-10" pInputText [formControlName]="controlName" [placeholder]="config.placeholder || ''"
            [attr.aria-label]="config.label" [style]="config.style" [readOnly]="config.validators?.readonly" />
          <button pButton label="Search" class="primary-button ml-auto" [disabled]="group.get(controlName)?.invalid"
            icon="pi pi-search" (click)="searchClicked.emit()"></button>
        </div>
        }

        <!-- Text Input -->
        <input class="w-full" *ngIf="config!.type === 'text'" pInputText [formControlName]="controlName"
          [placeholder]="config.placeholder || ''" [attr.aria-label]="config.label" [style]="config.style"
          [readOnly]="config.validators?.readonly" />

        @if(config!.type === 'search') {
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-search"></i>
          </p-inputgroup-addon>
          <input class="w-full border-left-none" pInputText [formControlName]="controlName"
            [placeholder]="config.placeholder || ''" [attr.aria-label]="config.label" [style]="config.style"
            [readOnly]="config.validators?.readonly" />
        </p-inputgroup>
        }

        <p-autocomplete class="w-full" *ngIf="config!.type === 'autoComplete'" [formControlName]="controlName"
          [placeholder]="config.placeholder || ''" [attr.aria-label]="config.label" [style]="config.style"
          [disabled]="config.validators?.readonly" [suggestions]="config.suggestions!" [styleClass]="'w-full'"
          [inputStyleClass]="'w-full'" [lazy]="false" [virtualScroll]="true" [virtualScrollItemSize]="34"
          scrollHeight="250px" [minLength]="1" (completeMethod)="onCompleteMethod($event)"
          (onSelect)="onSelectOfSuggestion($event)" [showClear]="true" (onClear)="onClearEvent($event)"></p-autocomplete>

        <!-- Password -->
        <input class="w-full" *ngIf="config!.type === 'password'" pPassword [formControlName]="controlName"
          [attr.aria-label]="config.label" />

        <!-- Dropdown -->
        <p-select class="w-full" *ngIf="config!.type === 'dropdown'" [options]="config.options || []"
          [formControlName]="controlName" [placeholder]="config.placeholder" [attr.aria-label]="config.label">
        </p-select>

        <!-- Radio Buttons -->
        <div class="w-full flex gap-3" *ngIf="config!.type === 'radio'">
          <div *ngFor="let opt of config.options || []; trackBy: trackByOption" class="flex align-items-center">
            <p-radioButton [value]="opt.value" [formControlName]="controlName" [inputId]="controlName + '_' + opt.value">
            </p-radioButton>
            <label [for]="controlName + '_' + opt.value" class="ml-2">{{ opt.label }}</label>
          </div>
        </div>

        <!-- Checkbox -->
        <p-checkbox class="w-full" *ngIf="config!.type === 'checkbox'" [binary]="true" [formControlName]="controlName"
          [inputId]="controlName" [attr.aria-label]="config.label">
        </p-checkbox>

        <!-- Textarea -->
        <textarea class="w-full" *ngIf="config!.type === 'textarea'" pTextarea [formControlName]="controlName"
          [attr.aria-label]="config.label">
      </textarea>

        <!-- Other Components -->
        <p-slider class="w-full" *ngIf="config!.type === 'slider'" [formControlName]="controlName"
          [style]="config.style" [disabled]="config.validators?.readonly"></p-slider>

        <p-datepicker [inputId]="config.type+config.key" [inputStyleClass]="'w-full'" [appendTo]="'body'" class="w-full"
          *ngIf="config!.type === 'date12WithTime'" [formControlName]="controlName" [showIcon]="true"
          [style]="config.style" [disabled]="config.validators?.readonly" [showButtonBar]="true" [hourFormat]="'12'"
          [showTime]="true" [showClear]="true" [showSeconds]="config.showSeconds! "
          [todayButtonStyleClass]="'primary-button'" [clearButtonStyleClass]="'secondary-button'" [showOnFocus]="true"
          [readonlyInput]="false" [minDate]="config.validators!.minDate"
          [maxDate]="config.validators!.maxDate"></p-datepicker>

        <p-datepicker [inputId]="config.type+config.key" [inputStyleClass]="'w-full'" [appendTo]="'body'" class="w-full"
          *ngIf="config!.type === 'date24WithTime'" [formControlName]="controlName" [showIcon]="true"
          [style]="config.style" [disabled]="config.validators?.readonly" [showButtonBar]="true" [hourFormat]="'24'"
          [showTime]="true" [showClear]="true" [showSeconds]="config.showSeconds! "
          [todayButtonStyleClass]="'primary-button'" [clearButtonStyleClass]="'secondary-button'" [showOnFocus]="true"
          [readonlyInput]="false" [minDate]="config.validators!.minDate"
          [maxDate]="config.validators!.maxDate"></p-datepicker>

        <p-datepicker [inputId]="config.type+config.key" [inputStyleClass]="'w-full'" [appendTo]="'body'" class="w-full"
          *ngIf="config!.type === 'date'" [formControlName]="controlName" [showIcon]="true" [style]="config.style"
          [disabled]="config.validators?.readonly" [showButtonBar]="true" [showTime]="false" [showClear]="true"
          [todayButtonStyleClass]="'primary-button'" [clearButtonStyleClass]="'secondary-button'" [showOnFocus]="true"
          [readonlyInput]="false" [minDate]="config.validators!.minDate"
          [maxDate]="config.validators!.maxDate"></p-datepicker>


        <p-datepicker [inputId]="config.type+config.key" [inputStyleClass]="'w-full'" [appendTo]="'body'" class="w-full"
          *ngIf="config!.type === 'rangeWithTime24'" [selectionMode]="'range'" [formControlName]="controlName"
          [showIcon]="true" hourFormat="24" [style]="config.style" [disabled]="config.validators?.readonly"
          [showButtonBar]="true" [showTime]="true" [showClear]="true" [showSeconds]="config.showSeconds! "
          [todayButtonStyleClass]="'primary-button'" [clearButtonStyleClass]="'secondary-button'"
          [minDate]="config.validators!.minDate" [maxDate]="config.validators!.maxDate"></p-datepicker>

        <p-datepicker [inputId]="config.type+config.key" [inputStyleClass]="'w-full'" [appendTo]="'body'" class="w-full"
          *ngIf="config!.type === 'rangeWithTime12'" [selectionMode]="'range'" [formControlName]="controlName"
          [showIcon]="true" hourFormat="12" [inputStyle]="config.style" [showButtonBar]="true" [showTime]="true"
          [showClear]="true" [showSeconds]="config.showSeconds! " [todayButtonStyleClass]="'primary-button'"
          [clearButtonStyleClass]="'secondary-button'" [minDate]="config.validators!.minDate"
          [maxDate]="config.validators!.maxDate"></p-datepicker>

        <p-datepicker [inputId]="config.type+config.key" [inputStyleClass]="'w-full'" [appendTo]="'body'" class="w-full"
          *ngIf="config!.type === 'rangeWithoutTime'" [selectionMode]="'range'" [formControlName]="controlName"
          [showIcon]="true" [style]="config.style" [disabled]="config.validators?.readonly" [showButtonBar]="true"
          [showTime]="false" [showClear]="true" [showSeconds]="config.showSeconds! "
          [todayButtonStyleClass]="'primary-button'" [clearButtonStyleClass]="'secondary-button'"
          [minDate]="config.validators!.minDate" [maxDate]="config.validators!.maxDate"></p-datepicker>

        <p-colorPicker class="w-full" *ngIf="config!.type === 'colorPicker'" [formControlName]="controlName"
          [style]="config.style" [disabled]="config.validators?.readonly"></p-colorPicker>

        <p-inputNumber class="w-full" *ngIf="config!.type === 'number'" [formControlName]="controlName"
          [style]="config.style" [disabled]="config.validators?.readonly"></p-inputNumber>

        <p-inputMask class="w-full" *ngIf="config!.type === 'mask'" [mask]="config.additionalProps?.mask"
          [formControlName]="controlName" [style]="config.style" [disabled]="config.validators?.readonly"></p-inputMask>
        <p-inputOtp class="w-full" *ngIf="config!.type === 'otp'" [formControlName]="controlName" [style]="config.style"
          [disabled]="config.validators?.readonly"></p-inputOtp>

        <p-knob class="w-full" *ngIf="config!.type === 'knob'" [formControlName]="controlName" [style]="config.style"
          [readonly]="config.validators?.readonly"></p-knob>

        <p-multiSelect class="w-full" *ngIf="config!.type === 'multiSelect'" [options]="config.options"
          [formControlName]="controlName" [appendTo]="'body'" [optionLabel]="'label'" [optionValue]="'value'"
          display="chip" [style]="config.style" [disabled]="config.validators?.readonly"
          [loading]="config.loading!"></p-multiSelect>

        <!-- <p-treeSelect class="w-full" *ngIf="config!.type === 'treeSelect'" [options]="config.options"
          [formControlName]="controlName" [style]="config.style" [readOnly]="config.validators?.readonly"></p-treeSelect> -->
        <p-toggleButton class="w-full" *ngIf="config!.type === 'toggleButton'" [formControlName]="controlName"
          [style]="config.style" [disabled]="config.validators?.readonly"></p-toggleButton>
        <p-toggleswitch class="w-full" *ngIf="config!.type === 'toggleSwitch'" [formControlName]="controlName"
          [style]="config.style" [disabled]="config.validators?.readonly"></p-toggleswitch>
        <p-rating class="w-full" *ngIf="config!.type === 'rating'" [formControlName]="controlName"
          [style]="config.style" [readonly]="config.validators?.readonly"></p-rating>
        <p-selectButton class="w-full" *ngIf="config!.type === 'selectButton'" [options]="config.options"
          [formControlName]="controlName" [style]="config.style"
          [disabled]="config.validators?.readonly"></p-selectButton>
        <p-select class="w-full" *ngIf="config!.type === 'select'" [filter]="config.filter" [options]="config.options"
          [formControlName]="controlName" [appendTo]="'body'" [style]="config.style"
          [disabled]="config.validators?.readonly" optionDisabled="disabled">
        </p-select>
        <p-autocomplete inputId="multiple-ac-2" multiple fluid [typeahead]="false" class="w-full"
          *ngIf="config!.type === 'chips'" [formControlName]="controlName" [styleClass]="'w-full'" separator="," />
        <p-editor class="w-full" *ngIf="config!.type === 'editor'" [style]="{ height: '320px' }"
          [formControlName]="controlName" [style]="config.style" [readonly]="config.validators?.readonly"></p-editor>

        <p-toggleswitch class="w-full" *ngIf="config!.type === 'toggleswitch'" [formControlName]="controlName"
          [style]="config.style" [disabled]="config.validators?.readonly" />

        <p-tree class="w-full" *ngIf="config!.type === 'tree'" [value]="config.options" selectionMode="checkbox"
          styleClass="w-full md:w-[30rem] border-2 border-200" [(selection)]="selectedFiles"
          [style]="{height: '100%',maxHeight: '250px',overflow: 'auto'}" [filter]="config.filter"
          (onNodeSelect)="onSelectedTreeNode($event)" (onNodeUnselect)="onSelectedTreeNode($event)" />

        <p-treeselect class="w-full" *ngIf="config!.type === 'treeSelect'" [formControlName]="controlName"
          [style]="config.style" [options]="config.options"
          placeholder="Select Item" [filter]="config.filter" appendTo="body" [scrollHeight]="'150px'"
          containerStyleClass="w-full" />

        <!-- Validation Errors -->
        <ng-container
          *ngIf="group.get(controlName)?.invalid && (group.get(controlName)?.dirty || group.get(controlName)?.touched)">
          <small class="text-red-500" *ngIf="group.get(controlName)?.hasError('required')">
            {{ config.label }} is required.
          </small>
          <small class="text-red-500"
            *ngIf="group.get(controlName)?.hasError('email') && group.get(controlName)?.hasError('pattern')">
            Enter a valid email address.
          </small>
          <small class="text-red-500" *ngIf="group.get(controlName)?.hasError('minlength')">
            Minimum {{ group.get(controlName)?.errors?.['minlength']?.requiredLength }} characters required.
          </small>
          <small class="text-red-500" *ngIf="group.get(controlName)?.hasError('maxlength')">
            Maximum {{ group.get(controlName)?.errors?.['maxlength']?.requiredLength }} characters allowed.
          </small>
          <small class="text-red-500"
            *ngIf="!group.get(controlName)?.hasError('email') && group.get(controlName)?.hasError('pattern')">
            Invalid format.
          </small>
        </ng-container>
      </div>
    </form>
  </div>
</ng-container>

<ng-template #emptyField>
  <div class="col-6" [style]="config.style"></div>
</ng-template>
